import React, { useState } from "react";
import addFees from '../../../../../assets/images/add_fees.svg';
import removeFees from '../../../../../assets/images/remove_fees.svg';
import { formatDecimal as fmt } from '../helpers/paymentsHelper';

const CompaniesTable = ({
  data,
  updateSiteOverviewTrips,
  selectStyles,
  currentPage,
  hasMore,
  fetchSiteOverview,
  handleNext,
  handleBack,
  isAdmin,
}) => {
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [searchTerm, setSearchTerm] = useState("");

  const commentOptions = [
    { label: "Adhoc Passenger", value: "Adhoc Passenger" },
    { label: "Adhoc Trip", value: "Adhoc trip" },
    { label: "Late Booking", value: "late booking" },
    { label: "Only Trip in Timeslot", value: "only trip in timeslot" },
    { label: "Other Passenger Cancelled", value: "other passenger cancelled" },
    { label: "Outlier", value: "outlier" },
    { label: "Add reason", value: "" },
  ];

  // edit table
  const [editingRowId, setEditingRowId] = useState(null);
  const [formData, setFormData] = useState({});
  const [showNoChargeConfirm, setShowNoChargeConfirm] = useState({ show: false, item: null });

  const handleEditClick = (item) => {
    setEditingRowId(item.id);
    setFormData({
      actual_kms: item.actual_kms,
      comments: item.comments,
    });
  };

  const handleCancelClick = (item) => {
    setEditingRowId(null);
  };

  const handleSaveClick = (item) => {
    const raw = formData.actual_kms || '';

    // Extract numeric part from string like "10", "10km", " 10 km", etc.
    const numericValue = parseFloat(raw.toString().replace(/[^\d.]/g, ''));

    const formattedFormData = {
      ...formData,
      actual_kms: isNaN(numericValue) ? '' : `${numericValue} km`
    };

    updateSiteOverviewTrips(item.id, formattedFormData);

    setEditingRowId(null);
  };

  const handleMarkNoCharge = async (item) => {
    try {
      await fetch(`/payments/mark_no_charge/${item.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
      });
      setEditingRowId(null);
      // refresh current page data without resetting pagination
      fetchSiteOverview(currentPage);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  const handleMarkNoChargeRestore = async (item) => {
    try {
      await fetch(`/payments/mark_no_charge_restore/${item.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
      });
      setEditingRowId(null);
      // refresh current page data without resetting pagination
      fetchSiteOverview(currentPage);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  const openNoChargeConfirm = (item) => {
    setShowNoChargeConfirm({ item, show: true });
  };

  const closeNoChargeConfirm = () => {
    setShowNoChargeConfirm({ item: null, show: false });
  };

  const handleInputChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: e.target.value,
    });
  };

  // const handleSelectChange = (selectedOption) => {
  //   setFormData({
  //     ...formData,
  //     comments: selectedOption ? selectedOption.value : '',
  //   });
  // };
  // eof edit table

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = [...data.grouped_trip_data].sort((a, b) => {
    if (sortConfig.key) {
      if (sortConfig.direction === "asc") {
        return a[sortConfig.key] > b[sortConfig.key] ? 1 : -1;
      } else {
        return a[sortConfig.key] < b[sortConfig.key] ? 1 : -1;
      }
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const search = searchTerm.toLowerCase();
    const keysToSearch = [
      "tracking",
      "id",
      "type",
      "driver",
      "fleet",
      "vehicle_type",
    ];
    return keysToSearch.some((key) =>
      item[key]?.toString().toLowerCase().includes(search)
    );
  });

  return (
    <div className="w-full h-full">
      <div className="justify-between flex w-full">
        <div className="px-2" style={{ maxWidth: "220px" }}>
          <div className="relative flex items-center">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ paddingTop: "0.44rem", paddingBottom: "0.44rem" }}
              className="w-full pl-4 pr-10 text-gray-800 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 placeholder-gray-400 placeholder-opacity-100 font-light text-sm"
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                ></path>
              </svg>
            </div>
          </div>
        </div>

        {/* <div className="px-2" style={{ maxWidth: '220px' }}>
          <button className="flex items-center gap-2 p-2 bg-purple-600 rounded hover:bg-purple-200 text-white">
            Save all
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 1V5H5.00001V1M3.00001 1H13L17.0001 5V15C17.0001 15.5304 16.7893 16.0391 16.4143 16.4142C16.0392 16.7893 15.5305 17 15.0001 17H3.00001C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3.00001 1ZM7.00002 11C7.00002 11.5304 7.21074 12.0391 7.58581 12.4142C7.96089 12.7893 8.46959 13 9.00003 13C9.53046 13 10.0392 12.7893 10.4142 12.4142C10.7893 12.0391 11 11.5304 11 11C11 10.4696 10.7893 9.96086 10.4142 9.58579C10.0392 9.21071 9.53046 9 9.00003 9C8.46959 9 7.96089 9.21071 7.58581 9.58579C7.21074 9.96086 7.00002 10.4696 7.00002 11Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div> */}
      </div>

      <table className="border-collapse w-full h-10/12 overflow-y-auto">
        <thead className="sticky top-0 bg-white z-10">
          <tr>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("tracking")}
            >
              Tracking{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "tracking" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "tracking" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("date")}
            >
              Date{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "date" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "date" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("weekday")}
            >
              Weekday{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "weekday" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "weekday" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("time")}
            >
              Time{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "time" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "time" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("type")}
            >
              Type{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "type" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "type" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("fleet")}
            >
              Fleet{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "fleet" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "fleet" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("driver")}
            >
              Driver{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "driver" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "driver" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            {isAdmin && (
              <>
                <th
                  className="border-b p-2 cursor-pointer text-left"
                  onClick={() => handleSort("vehicle_type")}
                >
                  Vehicle{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="32"
                    className="inline-block ml-1"
                  >
                    <path
                      d="M12 5l-5 5h10l-5-5z"
                      fill={
                        sortConfig.key === "vehicle_type" &&
                        sortConfig.direction === "asc"
                          ? "#745D96"
                          : "#9C9C9C"
                      }
                    />

                    <path
                      d="M12 19l5-5H7l5 5z"
                      fill={
                        sortConfig.key === "vehicle_type" &&
                        sortConfig.direction === "desc"
                          ? "#745D96"
                          : "#9C9C9C"
                      }
                    />
                  </svg>
                </th>
                <th
                  className="border-b p-2 cursor-pointer text-left"
                  onClick={() => handleSort("occupancy")}
                >
                  Occ{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="32"
                    className="inline-block ml-1"
                  >
                    <path
                      d="M12 5l-5 5h10l-5-5z"
                      fill={
                        sortConfig.key === "occupancy" &&
                        sortConfig.direction === "asc"
                          ? "#745D96"
                          : "#9C9C9C"
                      }
                    />

                    <path
                      d="M12 19l5-5H7l5 5z"
                      fill={
                        sortConfig.key === "occupancy" &&
                        sortConfig.direction === "desc"
                          ? "#745D96"
                          : "#9C9C9C"
                      }
                    />
                  </svg>
                </th>
                <th
                  className="border-b p-2 cursor-pointer text-left"
                  onClick={() => handleSort("pax")}
                >
                  Pax{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="32"
                    className="inline-block ml-1"
                  >
                    <path
                      d="M12 5l-5 5h10l-5-5z"
                      fill={
                        sortConfig.key === "pax" &&
                        sortConfig.direction === "asc"
                          ? "#745D96"
                          : "#9C9C9C"
                      }
                    />

                    <path
                      d="M12 19l5-5H7l5 5z"
                      fill={
                        sortConfig.key === "pax" &&
                        sortConfig.direction === "desc"
                          ? "#745D96"
                          : "#9C9C9C"
                      }
                    />
                  </svg>
                </th>
              </>
            )}
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("cancels")}
            >
              Cancels{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "cancels" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "cancels" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            {isAdmin && (
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort("fare")}
              >
                Fare{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1"
                >
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === "fare" && sortConfig.direction === "asc"
                        ? "#745D96"
                        : "#9C9C9C"
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === "fare" &&
                      sortConfig.direction === "desc"
                        ? "#745D96"
                        : "#9C9C9C"
                    }
                  />
                </svg>
              </th>
            )}
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("tier")}
            >
              Trip Tier{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "tier" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "tier" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("trip_kms")}
            >
              Trip KMs{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "trip_kms" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "trip_kms" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("actual_kms")}
            >
              Actual KMs{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "actual_kms" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />

                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "actual_kms" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
            <th
              className="border-b p-2 cursor-pointer text-left"
              onClick={() => handleSort("comments")}
            >
              Comments{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="32"
                className="inline-block ml-1"
              >
                <path
                  d="M12 5l-5 5h10l-5-5z"
                  fill={
                    sortConfig.key === "comments" && sortConfig.direction === "asc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
                <path
                  d="M12 19l5-5H7l5 5z"
                  fill={
                    sortConfig.key === "comments" && sortConfig.direction === "desc"
                      ? "#745D96"
                      : "#9C9C9C"
                  }
                />
              </svg>
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item) => {
            const rowHighlight = (item.tracking === 'incomplete' || item.no_charge) ? 'bg-red-100' : '';

            return (
            <tr key={item.id} className={`border-t border-b p-2 cursor-pointer ${rowHighlight}`}>
              <td className="border-t border-b p-2 text-left">
                {item.tracking === "accurate" ||
                item.tracking === "untracked" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      d="M9 19.2l-5.2-5.2 1.4-1.4L9 16.4l9.8-9.8 1.4 1.4L9 19.2z"
                      fill="green"
                    />
                  </svg>
                ) : item.tracking === "inaccurate" ? (
                  <svg
                    width="27"
                    height="24"
                    viewBox="0 0 27 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.6952 20.625C27.5625 22.125 26.4749 24 24.7451 24H2.25296C0.523153 24 -0.559732 22.1203 0.302826 20.625L11.5489 1.125C12.4161 -0.375 14.5819 -0.375 15.4492 1.125L26.6952 20.625ZM13.499 16.5938C12.3083 16.5938 11.3426 17.5594 11.3426 18.75C11.3426 19.9406 12.3083 20.9062 13.499 20.9062C14.6897 20.9062 15.6554 19.9406 15.6554 18.75C15.6554 17.5594 14.6897 16.5938 13.499 16.5938ZM11.4504 8.84531L11.7973 15.2203C11.8114 15.5203 12.0599 15.75 12.3599 15.75H14.6335C14.9335 15.75 15.1773 15.5156 15.196 15.2203L15.5429 8.84531C15.5617 8.52187 15.3038 8.25 14.9804 8.25H12.0083C11.6848 8.25 11.427 8.52187 11.4458 8.84531H11.4504Z"
                      fill="#F3986D"
                    />
                  </svg>
                ) : item.tracking === "incomplete" && (<svg
                  width="27"
                  height="24"
                  viewBox="0 0 27 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.6952 20.625C27.5625 22.125 26.4749 24 24.7451 24H2.25296C0.523153 24 -0.559732 22.1203 0.302826 20.625L11.5489 1.125C12.4161 -0.375 14.5819 -0.375 15.4492 1.125L26.6952 20.625ZM13.499 16.5938C12.3083 16.5938 11.3426 17.5594 11.3426 18.75C11.3426 19.9406 12.3083 20.9062 13.499 20.9062C14.6897 20.9062 15.6554 19.9406 15.6554 18.75C15.6554 17.5594 14.6897 16.5938 13.499 16.5938ZM11.4504 8.84531L11.7973 15.2203C11.8114 15.5203 12.0599 15.75 12.3599 15.75H14.6335C14.9335 15.75 15.1773 15.5156 15.196 15.2203L15.5429 8.84531C15.5617 8.52187 15.3038 8.25 14.9804 8.25H12.0083C11.6848 8.25 11.427 8.52187 11.4458 8.84531H11.4504Z"
                    fill="#FF0000"
                  />
                </svg>)}
              </td>
              <td className="border-t border-b p-2 text-left">{item.date}</td>
              <td className="border-t border-b p-2 text-left">
                {item.weekday}
              </td>
              <td className="border-t border-b p-2 text-left">{item.time}</td>
              <td className="border-t border-b p-2 text-left">{item.type}</td>
              <td className="border-t border-b p-2 text-left">{item.fleet}</td>
              <td className="border-t border-b p-2 text-left">{item.driver}</td>
              {isAdmin && (
                <>
                  <td className="border-t border-b p-2 text-left">
                    {item.vehicle_type}
                  </td>
                  <td className="border-t border-b p-2 text-left">
                    {item.occupancy}%
                  </td>
                  <td className="border-t border-b p-2 text-left">
                    {item.pax}
                  </td>
                </>
              )}
              <td className="border-t border-b p-2 text-left">
                {item.cancels}
              </td>
              {isAdmin && (
                <>
                  <td className="border-t border-b p-2 text-left">
                    {fmt(item.fare)}
                  </td>
                </>
              )}
              <td className="border-t border-b p-2 text-left">{item.tier}</td>
              <td className="border-t border-b p-2 text-left">
                {fmt(item.trip_kms)}
              </td>
              <td className="border-t border-b p-2 text-left">
                {editingRowId === item.id ? (
                  <input
                    type="text"
                    value={formData.actual_kms}
                    onChange={(e) => handleInputChange(e, "actual_kms")}
                    className="w-full px-2 text-gray-800 bg-white border border-gray-300 rounded-md focus:outline-none"
                  />
                ) : (
                  item.actual_kms
                )}
              </td>
              <td className="border-t border-b p-2 text-left">
                {editingRowId === item.id ? (
                  <input
                    type="text"
                    value={formData.comments}
                    onChange={(e) => handleInputChange(e, "comments")}
                    maxLength={50}
                    className="w-full p-2 text-gray-800 bg-white border border-gray-300 rounded-md focus:outline-none"
                  />
                ) : (
                  item.comments
                )}
              </td>
              <td className="border-t border-b p-2 space-x-1">
                {editingRowId === item.id ? (
                  <button
                    onClick={() => handleSaveClick(item)}
                    className="p-2 bg-green-600 rounded hover:bg-green-200"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path
                        d="M17 3H7C5.9 3 5 3.9 5 5v14c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-5zm-2 14H9v-2h6v2zm0-4H9v-2h6v2zm1-4V4.5L19.5 9H16z"
                        fill="white"
                      />
                    </svg>
                  </button>
                ) : (
                  <button
                    onClick={() => handleEditClick(item)}
                    className={
                      item.approved_by !== null
                        ? "hidden"
                        : "p-2 bg-purple-600 rounded hover:bg-purple-200"
                    }
                  >
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5389 2.59738L15.3481 5.41668C15.4665 5.53546 15.4665 5.72924 15.3481 5.84802L8.54613 12.6744L5.65589 12.9963C5.2697 13.04 4.94268 12.7119 4.98628 12.3243L5.30707 9.42372L12.1091 2.59738C12.2274 2.47861 12.4205 2.47861 12.5389 2.59738ZM17.5843 1.88162L16.0645 0.35632C15.5911 -0.118773 14.8218 -0.118773 14.3453 0.35632L13.2428 1.46279C13.1244 1.58156 13.1244 1.77535 13.2428 1.89412L16.052 4.71342C16.1704 4.83219 16.3635 4.83219 16.4818 4.71342L17.5843 3.60695C18.0577 3.12874 18.0577 2.35671 17.5843 1.88162ZM11.9596 10.8177V13.9996H1.99327V3.99766H9.15034C9.25 3.99766 9.34343 3.95702 9.41507 3.88826L10.6609 2.63802C10.8976 2.40047 10.7294 1.99727 10.3961 1.99727H1.49495C0.669613 1.99727 0 2.66927 0 3.49756V14.4997C0 15.328 0.669613 16 1.49495 16H12.4579C13.2832 16 13.9529 15.328 13.9529 14.4997V9.56749C13.9529 9.23305 13.5511 9.0674 13.3144 9.30182L12.0686 10.5521C12.0001 10.624 11.9596 10.7177 11.9596 10.8177Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}
                
                {editingRowId === item.id ? (
                  <button
                    onClick={() => openNoChargeConfirm(item)}
                    className="p-2 bg-purple-700 rounded hover:bg-purple-200 leading-none"
                    title={item.no_charge ? "Restore No Charge" : "Mark as No Charge"}
                  >
                    <img src={item.no_charge ? addFees : removeFees} alt="No Charge" className="block w-6 h-6" />
                  </button>
                ) : (
                  <button className="p-2 bg-gray-700 rounded hover:bg-gray-200">
                    <a href={`/grouped_trips/${item.id}`} target="_blank">
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 7C8 7.53043 8.21071 8.03914 8.58579 8.41421C8.96086 8.78929 9.46957 9 10 9C10.5304 9 11.0391 8.78929 11.4142 8.41421C11.7893 8.03914 12 7.53043 12 7C12 6.46957 11.7893 5.96086 11.4142 5.58579C11.0391 5.21071 10.5304 5 10 5C9.46957 5 8.96086 5.21071 8.58579 5.58579C8.21071 5.96086 8 6.46957 8 7Z"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M19 7C16.6 11 13.6 13 10 13C6.4 13 3.4 11 1 7C3.4 3 6.4 1 10 1C13.6 1 16.6 3 19 7Z"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </button>
                )}

                {editingRowId === item.id ? (
                  <button
                    onClick={() => handleCancelClick(item)}
                    className="p-2 bg-red-700 rounded hover:bg-red-200"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <line
                        x1="18"
                        y1="6"
                        x2="6"
                        y2="18"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <line
                        x1="6"
                        y1="6"
                        x2="18"
                        y2="18"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                ) : (
                  <button
                    className={
                      item.approved_by !== null
                        ? "hidden"
                        : "p-2 bg-gray-700 rounded hover:bg-gray-200"
                    }
                  >
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.19871 8.67352e-06C6.06 0.00323448 4.12129 0.845169 2.68581 2.21614L1.53742 1.06452C1.05033 0.577428 0.214844 0.922589 0.214844 1.60969V5.93549C0.214844 6.36452 0.560005 6.70968 0.989037 6.70968H5.31484C6.00516 6.70968 6.35032 5.8742 5.86323 5.3871L4.51484 4.03872C5.51162 3.10646 6.79871 2.59033 8.16645 2.57743C11.1471 2.55162 13.66 4.96452 13.6342 8.04194C13.6084 10.9677 11.2406 13.4194 8.21484 13.4194C6.88903 13.4194 5.6342 12.9452 4.6471 12.0774C4.49549 11.9419 4.26323 11.9516 4.11807 12.0968L2.83742 13.3774C2.67936 13.5355 2.68904 13.7903 2.85355 13.9387C4.27291 15.2194 6.15355 16 8.21484 16C12.6342 16 16.2148 12.4194 16.2148 8C16.2148 3.5871 12.6148 -0.00644294 8.19871 8.67352e-06Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}
              </td>
            </tr>
            );
          })}
          <tr>
            <td colSpan={2} className="px-4 py-3 bg-gray-50">
              <div className="flex justify-between items-center w-full">
                <span className="text-sm text-gray-700">
                  Page {currentPage}
                </span>

                <div className="flex items-center space-x-2">
                  <button
                    onClick={handleBack}
                    disabled={currentPage === 1}
                    aria-label="Previous Page"
                    className={`${
                      currentPage === 1
                        ? "bg-gray-500 hover:bg-gray-600"
                        : "bg-purple-500 hover:bg-purple-600 "
                    } 
                      text-white inline-flex items-center justify-center p-2 w-9 h-9 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-70 transition-colors duration-150 ease-in-out`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.75 19.5L8.25 12l7.5-7.5"
                      />
                    </svg>
                  </button>

                  <button
                    onClick={handleNext}
                    disabled={!data?.next_page}
                    aria-label="Next Page"
                    className={`${
                      !data?.next_page
                        ? "bg-gray-500 hover:bg-gray-600"
                        : "bg-purple-500 hover:bg-purple-600"
                    }
                      text-white inline-flex items-center justify-center p-2 w-9 h-9 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-70 transition-colors duration-150 ease-in-out`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 4.5l7.5 7.5-7.5 7.5"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {showNoChargeConfirm.show && (
        <div className="fixed inset-0 flex items-center justify-center z-40">
          <div className="fixed inset-0 bg-black opacity-50" onClick={closeNoChargeConfirm} />
          <div className="bg-white w-1/3 rounded-lg shadow-lg z-10 relative p-6 mx-4 break-words whitespace-normal">
            <h2 className="text-xl font-medium mb-3" style={{ color: '#6E6C71' }}>
              {showNoChargeConfirm.item?.no_charge ? 'Restore Charge' : 'Mark as No Charge'}
            </h2>
            <p className="text-gray-600 mb-4 break-words whitespace-normal">
              {showNoChargeConfirm.item?.no_charge
                ? 'This will include the trip back into client billing and driver payments. Continue?'
                : 'This will exclude the trip from client billing and driver payments. Continue?'}
            </p>
            <div className="flex justify-end space-x-2">
              <button
                onClick={closeNoChargeConfirm}
                className="px-6 py-2 bg-gray-300 text-gray-800 rounded text-sm hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const item = showNoChargeConfirm.item;
                  closeNoChargeConfirm();
                  if (item) {
                    if (item.no_charge) {
                      handleMarkNoChargeRestore(item);
                    } else {
                      handleMarkNoCharge(item);
                    }
                  }
                }}
                className="px-6 py-2 bg-purple-700 text-white rounded text-sm hover:bg-purple-800"
              >
                {showNoChargeConfirm.item?.no_charge ? 'Restore' : 'Confirm'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompaniesTable;
